import React, { Fragment } from "react";
import { Link } from "react-router-dom";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { slides } from "../../actions/slider";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = { slides: [] };
  }
  state = {
    button: false,
  };

  async componentDidMount() {
    const res = await this.props.slides();
    this.setState({ slides: res.data });
  }
  open1 = (abc) => {
    return abc === true ? (
      <>
        <a
          className="carousel-control-prev"
          href="#big-screenCarousel"
          role="button"
          data-slide="prev"
          onMouseEnter={() => this.setState({ button: true })}
          onMouseLeave={() => this.setState({ button: false })}
        >
          <span className="carousel-control-prev-icon" aria-hidden="true">
            <i className="fa fa-angle-left" />
          </span>
          <span className="sr-only">Previous</span>
        </a>
        <a
          onMouseEnter={() => this.setState({ button: true })}
          onMouseLeave={() => this.setState({ button: false })}
          className="carousel-control-next"
          href="#big-screenCarousel"
          role="button"
          data-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true">
            <i className="fa fa-angle-right" />
          </span>
          <span className="sr-only">Next</span>
        </a>
      </>
    ) : (
      <></>
    );
  };
  render() {
    return (
      <Fragment>
        {/* CAROUSEL AREA */}
        {this.state.slides.length > 0 && (
          <div
            id="top"
            className="top top-row max-1600"
            ref={(el) => (this.instance = el)}
          >
            <div id="big-screenCarousel">
              <OwlCarousel
                className="HomeOwlCarousel owl-theme"
                loop
                items={1}
                margin={0}
                nav
                responsiveClass={true}
              >
                {this.state.slides &&
                  this.state.slides.length > 0 &&
                  this.state.slides.map((item, index) => (
                    <Link to={item.slideUrl}>
                      <img
                        effect="blur"
                        src={item.image}
                        alt={item.name}
                        id="first-carousel-img"
                      />
                    </Link>
                  ))}
              </OwlCarousel>
            </div>
            <div
              id="smallSc-slider"
              className="carousel slide"
              data-ride="carousel"
            >
              <OwlCarousel
                className="owl-theme"
                loop
                items={1}
                margin={10}
                nav
                loop
                autoplaySpeed={true}
                autoplay={true}
                autoplayTimeout={3000}
                autoplayHoverPause={true}
                animateOut={true}
                responsiveClass={true}
              >
                {this.state.slides &&
                  this.state.slides.length > 0 &&
                  this.state.slides.map((item, index) => (
                    <Link to={item.slideUrl}>
                      <img
                        effect="blur"
                        src={item.image}
                        alt={item.name}
                        id="first-carousel-img"
                      />
                    </Link>
                  ))}
              </OwlCarousel>
            </div>
          </div>
        )}
        {/*// END CAROUSEL AREA */}
      </Fragment>
    );
  }
}
slides.propTypes = {
  slides: PropTypes.func.isRequired,
};

export default connect(null, { slides })(Slider);
